import styled, { css } from "styled-components";

export const SectionWrapper = styled.section<{
  fullHeight?: boolean;
  backgroundColor?: string;
  snap?: boolean;
}>`

  width: 100%;
  background: ${({ backgroundColor, theme }) =>
    backgroundColor || theme.colors.background};
  overflow: hidden;
  

  ${({ fullHeight }) =>
    fullHeight &&
    css`
      height: 100vh;
    `}

  ${({ snap }) =>
    snap &&
    css`
      scroll-snap-align: start;
      scroll-snap-stop: always;
    `}
`;